import React from "react";
import { useNavigate } from "react-router-dom";
import { Signup } from "../../components/Signup";

export function SignupPage() {
  const navigate = useNavigate();

  const handleSignup = () => {
    // Navigation will be handled by the auth context
    navigate("/dashboard");
  };

  const handleNavigateToLogin = () => {
    navigate("/auth/login");
  };

  return (
    <Signup onSignup={handleSignup} onNavigateToLogin={handleNavigateToLogin} />
  );
}
